export default __webpack_public_path__ + "static/media/Back_CVV.b60458cc.svg";